import React, { useEffect, useState } from 'react';
import Styled from './Reports.styled';
import CardReports from './components/CardReports';
import { ProfileService } from 'core/http/service/Profile.service';
import keycloak from 'core/config/keycloak';
import LocalidadeDTO from 'models/perfil/LocalidadeDTO';
import { FadCoursesService } from 'core/http/service/ferramentaAutoria/FadCourses.service';
import { FadCoursesModel } from 'models/ferramentaAutoria/FadCoursesModel';
import { ToastError, ToastSuccess } from 'components/Toaster';
import CardReportSolucoes from './components/CardReportSolucoes';
import CardReportRecurso from './components/CardReportRecurso';
import AdminRecursosCostumizados from 'core/http/service/admin/AdminRecursosCostumizados.service';
import { ResumoRecursoCustomizado } from 'models/recursos-costumizados/ResumoRecursoCustomizado';
import { fetchStorageFile } from 'hooks/StoreFiles';
import { Segmented, Table } from 'antd';
import { StorageFilesService } from 'core/http/service/StorageFiles.service';
import moment from 'moment';
import { FaDownload } from 'react-icons/fa';
import Colors from 'enums/Colors';

type Align = 'Gerar relatórios' | 'Relatórios para baixar';

export interface IStoraFiles {
    description: string;
    filepath: string;
    date: string;
}

export interface Reports {
    estado?: string | null;
    cidade?: string | null;
    escola?: string | null;
    dateInicio?: string | null;
    dateFim?: string | null;
}

const profileService = new ProfileService();
const coursesFadService = new FadCoursesService();
const adminRecursoCostumizadosService = new AdminRecursosCostumizados();
const storageService = new StorageFilesService();

const ReportsPageAdmin = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingSubmit, setLoadingSubmit] = useState<number>(-1);
    const [isLoadingCities, setIsLoadingCities] = useState(false);

    const [schoolName, setSchoolName] = useState<string>('');
    const [userSchools, setUserSchools] = useState<any[]>([]);
    const [notFoundSchool, setNotFoundSchool] = useState(false);
    const [inputSchoolDisabled, setSchoolDisabled] = useState<boolean>(true);

    const [cidades, setCidades] = useState<LocalidadeDTO[]>([]);
    const [estados, setEstados] = useState<any[]>([]);
    const [coursesFad, setCoursesFad] = useState<FadCoursesModel[]>([]);

    const [coursesItens, setCoursesItens] = useState<ResumoRecursoCustomizado[]>([]);

    const [estadoSelected, setEstadoSelected] = useState<string>('');
    const [cidadeSelected, setcidadeSelected] = useState<any>();
    const [courseSelected, setCourseSelected] = useState<any>();
    const [schoolSelected, setSchoolSelected] = useState<any>({});
    const [dataPeriodo, setDataPeriodo] = useState<string[]>([]);
    const [cidadesItem, setCidadesItem] = useState<LocalidadeDTO[]>([]);

    const [coursesItensSelected, setCoursesItensSelected] = useState<any>();
    const [estadoSelectedItem, setEstadoSelectedItem] = useState<string>('');
    const [cidadeSelectedItem, setcidadeSelectedItem] = useState<any>();
    const [schoolSelectedItem, setSchoolSelectedItem] = useState<any>({});
    const [dataPeriodoItem, setDataPeriodoItem] = useState<string[]>([]);

    const [relations, setRelations] = useState<IStoraFiles[]>([]);

    const [alignValue, setAlignValue] = React.useState<Align>('Gerar relatórios');

    const getUserSchools = async () => {
        if (keycloak.authenticated) {
            setLoading(true);

            const { data, status }: any = await profileService.findSchoolsAdmin(estadoSelected, cidadeSelected.label);

            if (status === 200) {
                setUserSchools(data);
            }

            setLoading(false);
            setSchoolDisabled(false);
        }
    };
    const getListCoursesItem = async () => {
        const { data, status }: any = await adminRecursoCostumizadosService.buscarListaResumidaItemAll();

        if (status === 200) {
            setCoursesItens(data);
        }
    };

    const getListCoursesFad = async () => {
        const { data, status }: any = await coursesFadService.findAllFadCourses();

        if (status === 200) {
            setCoursesFad(data);
        }
    };

    const loadCidadesPorUf = async () => {
        try {
            setCidades([]);
            setcidadeSelected(null);
            setIsLoadingCities(true);
            const response: any = await profileService.consultarCidadesPorUF(estadoSelected);
            const _cidades: LocalidadeDTO[] = response.data.map((item: any) => new LocalidadeDTO().fromJSON(item));
            setCidades(_cidades);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoadingCities(false);
        }
    };
    const loadCidadesPorUfItem = async () => {
        try {
            setCidades([]);
            setcidadeSelectedItem(null);
            setIsLoadingCities(true);
            const response: any = await profileService.consultarCidadesPorUF(estadoSelectedItem);
            const _cidades: LocalidadeDTO[] = response.data.map((item: any) => new LocalidadeDTO().fromJSON(item));
            setCidadesItem(_cidades);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoadingCities(false);
        }
    };

    const loadEstados = async () => {
        const { data, status } = await profileService.findAllEstados();

        if (status === 200) {
            setEstados(data);
        }
    };

    function cleanParams(params: Record<string, any>) {
        return Object.fromEntries(
            Object.entries(params).filter(([_, value]) => {
                return value !== undefined && value !== null && value !== '';
            })
        );
    }

    const handleRelatorioFad = async () => {
        if (!courseSelected) {
            return ToastError('Nenhum curso selecionado!');
        }
        setLoadingSubmit(1);

        try {
            const rawBody: Reports = {
                estado: estadoSelected.length > 0 ? estadoSelected : null,
                cidade: cidadeSelected?.label ?? null,
                escola: schoolSelected?.schoolName ?? null,
                dateInicio: dataPeriodo.length > 0 ? dataPeriodo[0] : null,
                dateFim: dataPeriodo.length > 0 ? dataPeriodo[1] : null,
            };

            const body = cleanParams(rawBody);

            const response = await coursesFadService.findRelatorioCourse(courseSelected.value, body);

            const blob = new Blob([response.data], { type: 'application/vnd.ms-excel;charset=UTF-8' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `relatorio-${new Date().toISOString().slice(0, 10)}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            ToastError('Ocorreu algum erro no servidor!');
            console.log('🚀 ~ handleRelatorioFad ~ error:', error);
        }

        setLoadingSubmit(-1);
    };

    const downloadArq = (arqLink: string, arqName: string) => {
        const fileUrl = fetchStorageFile(arqLink); // já retorna URL final
    
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', arqName || `relatorio-${new Date().toISOString().slice(0, 10)}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };
    
    const handleRelatorioItensRecurso = async () => {
        if (!coursesItensSelected) {
            return ToastError('Nenhum curso selecionado!');
        }

        try {
            setLoadingSubmit(2);

            const rawBody: Reports = {
                estado: estadoSelectedItem.length > 0 ? estadoSelectedItem : null,
                cidade: cidadeSelectedItem?.label ?? null,
                escola: schoolSelectedItem?.schoolName ?? null,
                dateInicio: dataPeriodoItem.length > 0 ? dataPeriodoItem[0] : null,
                dateFim: dataPeriodoItem.length > 0 ? dataPeriodoItem[1] : null,
            };

            const body = cleanParams(rawBody);

            const { status } = await adminRecursoCostumizadosService.findRelatorioCourse(coursesItensSelected.value, body);

            if (status == 200) {
                ToastSuccess('Solicitação do relátório enviada com sucesso.');
            }
        } catch (error) {
            ToastError('Ocorreu algum erro no servidor!');
            console.log('🚀 ~ handleRelatorioItensRecurso ~ error:', error);
        }

        setLoadingSubmit(-1);
    };

    const fetchRelations = async () => {
        const { data, status } = await storageService.fetchRelations();

        if (status === 200) {
            setRelations(
                data.map((d: any) => ({
                    description: d.description,
                    filepath: d.filepath,
                    date: d.dateCreated,
                }))
            );
        }
    };

    useEffect(() => {
        loadCidadesPorUf();
    }, [estadoSelected]);
    useEffect(() => {
        loadCidadesPorUfItem();
    }, [estadoSelectedItem]);

    useEffect(() => {
        if (cidadeSelected) {
            getUserSchools();
        }
    }, [cidadeSelected]);

    useEffect(() => {
        if (alignValue === 'Relatórios para baixar') {
            fetchRelations();
        }
    }, [alignValue]);

    useEffect(() => {
        loadEstados();
        getListCoursesFad();
        getListCoursesItem();
    }, []);

    return (
        <Styled.Container>
            <Styled.Title>Relatórios</Styled.Title>
            <Segmented
                value={alignValue}
                size="large"
                style={{ marginBottom: 8 }}
                onChange={setAlignValue}
                options={['Gerar relatórios', 'Relatórios para baixar']}
            />

            {alignValue != 'Relatórios para baixar' ? (
                <>
                    <CardReports
                        title="FERRAMENTA DE AUTORIA"
                        userSchools={userSchools}
                        schoolName={schoolName}
                        setNotFoundSchool={setNotFoundSchool}
                        setSchoolName={setSchoolName}
                        setSchoolSelected={setSchoolSelected}
                        inputSchoolDisabled={inputSchoolDisabled}
                        estados={estados}
                        setEstadoSelected={(v: any) => setEstadoSelected(v.value)}
                        cidades={cidades}
                        isLoadingCities={isLoadingCities}
                        setcidadeSelected={setcidadeSelected}
                        cidadeSelected={cidadeSelected}
                        setDataPeriodo={setDataPeriodo}
                        handleReports={handleRelatorioFad}
                        coursesFad={coursesFad}
                        setCourseSelected={setCourseSelected}
                        loadingSubmite={loadingSubmit}
                    />

                    <CardReportRecurso
                        title="RECURSOS"
                        userSchools={userSchools}
                        schoolName={schoolName}
                        setNotFoundSchool={setNotFoundSchool}
                        setSchoolName={setSchoolName}
                        setSchoolSelected={setSchoolSelectedItem}
                        inputSchoolDisabled={inputSchoolDisabled}
                        estados={estados}
                        setEstadoSelected={(v: any) => setEstadoSelectedItem(v.value)}
                        cidades={cidadesItem}
                        isLoadingCities={isLoadingCities}
                        setcidadeSelected={setcidadeSelectedItem}
                        cidadeSelected={cidadeSelectedItem}
                        setDataPeriodo={setDataPeriodoItem}
                        coursesItemRecurso={coursesItens}
                        setCourseSelected={setCoursesItensSelected}
                        handleReports={handleRelatorioItensRecurso}
                        loadingSubmite={loadingSubmit}
                    />

                    <CardReportSolucoes />
                </>
            ) : (
                <>
                    <Table
                        dataSource={relations}
                        columns={[
                            {
                                title: 'Nome',
                                dataIndex: 'description',
                                key: 'description',
                                render: (v: string) => <div>{v?.length > 0 ? v : 'Nenhum nome mencionado.'}</div>,
                            },
                            {
                                title: 'Filepath',
                                dataIndex: 'filepath',
                                key: 'filepath',
                            },
                            {
                                title: 'Data',
                                dataIndex: 'date',
                                key: 'date',
                                render: (v: string) => <div>{v != null ? moment(v).format('DD/MM/YYYY HH:mm:ss') : 'Data inválida.'}</div>,
                            },
                            {
                                title: 'Ações',
                                dataIndex: 'acoes',
                                key: 'acoes',
                                render: (_: any, record: any) => (
                                    <div>
                                        <FaDownload
                                            size={22}
                                            cursor={'pointer'}
                                            color={Colors.CloneGreen}
                                            onClick={() => downloadArq(record.filepath, record.description)}
                                        />
                                    </div>
                                ),
                            },
                        ]}
                        pagination={{ pageSize: 10 }}
                    />
                    ;
                </>
            )}
        </Styled.Container>
    );
};

export default ReportsPageAdmin;
